import React from "react";
import { Link } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";
import { LandingHeader } from "./landing/LandingHeader";
import Footer from "../partials/Footer";

export const Nopage = () => {
  return (
    <>
      <LandingHeader />
      <main
        style={{
          height: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="bg-white shadow rounded p-5 text-center"
          style={{ maxWidth: "500px", width: "100%" }}
        >
          <FaExclamationTriangle size={50} style={{ color: "#dc3545", marginBottom: "20px" }} />

          <h1 style={{ fontSize: "48px", fontWeight: "bold" }}>404</h1>

          <h3 className="mb-3">Page Not Found</h3>

          <p className="text-muted">
            Sorry, the page you are looking for does not exist or has been moved.
          </p>

          <div className="mt-4">
            <Link to="/" className="btn btn-primary me-2">
              Go Home
            </Link>
            <Link to="/login" className="btn btn-primary me-2">
              Login
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};